import { Button, Flex, Modal, Tag } from 'antd';
import { useContext, useState } from 'react';
import { LibraryContext } from './context-provider';

export default function DeleteFileModal({ open, setOpen }) {
   const { selectedLibrary, library } = useContext(LibraryContext);
   const [deleteLoading, setDeleteLoading] = useState(false);

   async function handleDelete() {
      setDeleteLoading(true);
      await library.bulkDelete(selectedLibrary.map((item) => item._id));
      setOpen(false);
      setDeleteLoading(false);
   }

   return (
      <Modal
         title={`Delete ${selectedLibrary?.length} ${selectedLibrary?.length > 1 ? 'items' : 'item'}`}
         open={open}
         onCancel={() => setOpen(false)}
         footer={[
            <Button key="back" onClick={() => setOpen(false)}>
               Cancel
            </Button>,
            <Button danger key="submit" type="primary" onClick={handleDelete} loading={deleteLoading}>
               Delete
            </Button>,
         ]}
      >
         <Flex vertical gap={32}>
            <p>
               Are you sure you want to delete
               {selectedLibrary?.length > 1 ? ' these items' : ' this item'}?
            </p>
            <Flex wrap="wrap" gap={4}>
               {selectedLibrary?.map((item) => (
                  <Tag key={item._id}>
                     <Flex gap={8} align="center">
                        {item.type === 'file' && <i className="fi fi-rr-file" style={{ fontSize: 16 }} />}
                        {item.type === 'folder' && (
                           <i className="fi fi-sr-folder" style={{ fontSize: 16, color: item.color }} />
                        )}
                        {item.name}
                     </Flex>
                  </Tag>
               ))}
            </Flex>
         </Flex>
      </Modal>
   );
}
